import { useSelector, useDispatch } from "react-redux";
import { openToast, closeToast, updateToast } from "store/modules/common/toastReducer";

const useToast = () => {
    const toastState = useSelector((state) => state.toastReducer);
    const dispatch = useDispatch();

    const handleOpenToast = (info) => {
        dispatch(openToast(info));
    };

    const handleCloseToast = () => {
        dispatch(closeToast());
    };

    const handleUpdateToast = (info) => {
        dispatch(updateToast(info));
    };

    return {
        toastState,
        openToast: handleOpenToast,
        closeToast: handleCloseToast,
        updateToast: handleUpdateToast,
    };
};

export default useToast;
